import type { DropDownListChangeEvent } from "@tql/ui-components-react/kendo/dropdowns";
import { DropDownList } from "@tql/ui-components-react/tql/dropdowns";
import React, { useState } from "react";

import styles from "../slider-filter/slider-filter.module.css";

type ServiceLevelFilterProps = {
	data: string[];
	onChange: (value: string[]) => void;
};

type DropDownValueElement = React.ReactElement<{
	children?: React.ReactNode;
}>;

const SERVICE_LEVEL_DEFAULT_ITEM = "Service Level";

const getServiceLevelAbbreviation = (value: string): string => {
	const normalizedValue = value.trim();

	return normalizedValue.charAt(0).toUpperCase();
};

export const ServiceLevelFilter = ({
	data,
	onChange,
}: ServiceLevelFilterProps) => {
	const [selectedServiceLevel, setSelectedServiceLevel] = useState<
		string | null
	>(null);
	const selectedText = selectedServiceLevel
		? `(${getServiceLevelAbbreviation(selectedServiceLevel)})`
		: "";

	const handleChange = (event: DropDownListChangeEvent) => {
		const value =
			typeof event.value === "string" &&
			event.value !== SERVICE_LEVEL_DEFAULT_ITEM
				? event.value
				: null;

		setSelectedServiceLevel(value);
		onChange(value ? [value] : []);
	};

	const valueRender = (element: DropDownValueElement) => {
		return React.cloneElement(
			element,
			element.props,
			<>
				<span className={styles.sliderFilterLabel}>Service Level</span>
				{selectedText ? (
					<span className={styles.sliderFilterValue}>{selectedText}</span>
				) : null}
			</>,
		);
	};

	return (
		<DropDownList
			data={data}
			defaultItem={SERVICE_LEVEL_DEFAULT_ITEM}
			id={"service-levels"}
			onChange={handleChange}
			value={selectedServiceLevel}
			valueRender={valueRender}
		/>
	);
};
